import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getHoursAndMinutes } from '@meitu/saas-editor-core/es/utils/common-kit';
import { getLocaleStore } from '@/i18n';

export enum SAVE_TYPE {
    HANDLE = 'handle',
    AUTO = 'auto',
    DOWNLOAD = 'download',
}

export interface ISaveInfoModel {
    destroy: () => void;
    isSaving: boolean;
    isAutoSaving: boolean;
    saveTooltipText: string;
    saveType: SAVE_TYPE | '';
    setIsSaving: (payload: boolean) => void;
    setSaveType: (payload: SAVE_TYPE) => void;
    setIsAutoSaving: (payload: boolean) => void;
    changeSaveTooltipText: (payload: boolean) => void;
    resetSaveTooltipText: () => void;
    /**
     * 历史记录变更是否需要触发自动保存
     * 进入编辑器，只是替换模版，不需要触发自动保存
     */
    isNeedAutoSave: boolean;
    /** 设置历史记录变更是否需要触发自动保存 */
    setIsNeedAutoSave: (payload: boolean) => void;
    /** 获取保存状态 */
    getSaveState: () => { isNeedAutoSave: boolean; isAutoSaving: boolean; isSaving: boolean };
}

const useSaveInfoModel = create<ISaveInfoModel>()(
    immer((set, get) => ({
        destroy: () =>
            set((state) => {
                state.isAutoSaving = false;
                state.isSaving = false;
                state.saveTooltipText = '';
                state.saveType = '';
                state.isNeedAutoSave = false;
            }),
        isSaving: false,
        isAutoSaving: false,
        saveType: '',
        saveTooltipText: '',
        setIsSaving: (payload) =>
            set((state) => {
                state.isSaving = payload;
            }),

        setSaveType: (payload) =>
            set((state) => {
                state.saveType = payload;
            }),

        setIsAutoSaving: (payload) =>
            set((state) => {
                state.isAutoSaving = payload;
            }),

        changeSaveTooltipText: (payload) =>
            set((state) => {
                const { $t } = getLocaleStore();
                state.saveTooltipText = payload
                    ? $t((v, { r }) => r(v.editor.models.saved, [getHoursAndMinutes()]))
                    : $t((v) => v.header.save);
            }),
        resetSaveTooltipText: () =>
            set((state) => {
                state.saveTooltipText = '';
            }),

        isNeedAutoSave: false,
        setIsNeedAutoSave: (payload) =>
            set((state) => {
                state.isNeedAutoSave = payload;
            }),

        /** 获取保存状态 */
        getSaveState: () => ({
            isNeedAutoSave: get().isNeedAutoSave,
            isAutoSaving: get().isAutoSaving,
            isSaving: get().isSaving,
        }),
    })),
);

export { useSaveInfoModel };
export const getSaveInfoModel = () => useSaveInfoModel.getState();
